import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, patch, post, put } from './agent';
import reportFiles from './reportFiles';

const reports = (workspacesUrl) => (reportId) => {
  const url = _([workspacesUrl, 'reports', reportId]).compact().join('/');

  return {
    list: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
    info: () => get(`${url}/info`),
    data: (query = {}, config) => get(url.concat(new QueryString(query, { multi: true }).toString(true)), config),
    add: (params) => post(url, params),
    update: (params) => patch(url, params),
    remove: () => del(url),

    reportFiles: reportFiles(url.concat('/report-files')),

    favorites: {
      add: () => post(url.concat('/favorite')),
      remove: () => del(url.concat('/favorite')),
    },

    pinned: {
      add: () => post(url.concat('/pinned')),
      remove: () => del(url.concat('/pinned')),
    },

    schedules(id) {
      const url = _([workspacesUrl, 'reports', 'schedules', id]).compact().join('/');
      return {
        list: (query = {}) => get(url.concat(new QueryString(query).toString(true))),
        get: () => get(url),
        create: (params) => post(url, params),
        update: (params) => patch(url, params),
        setActiveStatus: (flag = true) => put(`${url}/is-active`, { isActive: flag }),
        delete: () => del(url),
        run: () => post(url.concat('/run')),
      };
    },

    exports: (query = {}) => get(url.concat('/exports').concat(new QueryString(query, { multi: true }).toString(true))),
  };
};

export default reports;
